module.exports = __webpack_public_path__ + "media/images/iconInfo__inactive--dark-52c9eb6616b690c6305cbe5abd7e3f5e.png";